import { buildRefreshParameters, getTabularReducerInfo } from "./common"
import { apiGet, apiPost } from "../../utils/apiConnector"
import { inventoryApi } from "../../config/apiUrls"
import { alertTypes, showMessage } from "../alerts"

// Thunk
export function refresh() {
  return (dispatch, getState) => {
    const state = getState()
    const storeId = state.profile.currentStore.id
    dispatch(actions.setLoading(true))
    return apiGet(
      inventoryApi,
      buildRefreshParameters(storeId, state.inventories),
    )
      .onOk((res) => {
        dispatch(
          actions.setData(
            res.data.response.inventories.map((i) => ({
              ...i,
              id: i.inventoryId,
            })),
          ),
        )
        dispatch(actions.setTotalPages(res.data.response.pages))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function startInventory(data) {
  return (dispatch, getState) => {
    if (data.title) {
      const state = getState()
      data.storeId = state.profile.currentStore.id
      dispatch(actions.setLoading(true))

      return apiPost(inventoryApi, data)
        .onOk(() => {
          dispatch(refresh())
        })
        .useDefaultErrorHandlers(dispatch)
        .afterAll(() => {
          dispatch(actions.setLoading(false))
        })
        .startSingle()
    } else {
      dispatch(showMessage("Пожалуйста, введите название", alertTypes.error))
    }
  }
}

const { actions, reducer, thunks } = getTabularReducerInfo(
  "INVENTORIES",
  refresh,
)
export default reducer
export const { openPage, filter, clear, search, sort } = thunks
